const base = '/analytics';

const AnalyticsApi = {
  base,
  dashboard: base + '/dashboard',
  transactionChart: base + '/transaction-chart'
};

export default AnalyticsApi;
